<template>
  <div class="recommend-program">
    <label class="label">
      <input
        v-model="checked"
        class="checkbox"
        type="checkbox"
        :value="program.id"
        :name="inputName"
        @change="$emit('change')"
      >
      <span class="pseudo-checkbox program-name">{{ program.name }}</span>
      <p class="agent-name">{{ program.agent_name }}</p>
      <p class="age-name">{{ program.age_name }}向け</p>
      <span :class="buttonClass">{{ buttonLabel }}</span>
    </label>
  </div>
</template>

<script>

export default {
  props: {
    program: {
      type: Object,
      required: true
    },

    inputName: {
      type: String,
      required: true
    }
  },

  data: function () {
    return {
      checked: true
    }
  },

  computed: {
    buttonClass: function () {
      return {
        button: true,
        'button-add': !this.checked,
        'button-remove': this.checked
      }
    },

    buttonLabel: function () {
      return this.checked ? '削除する' : '追加する'
    }
  }
}
</script>
